// extracted by mini-css-extract-plugin
export default {"wrapper":"Modal_wrapper__mrOZw","container":"Modal_container__Pdqv8","button":"Modal_button__Z2XAS"};